import { render, staticRenderFns } from "./ConfigMenu.vue?vue&type=template&id=4315ca00"
import script from "./ConfigMenu.vue?vue&type=script&lang=js"
export * from "./ConfigMenu.vue?vue&type=script&lang=js"
import style0 from "./ConfigMenu.vue?vue&type=style&index=0&id=4315ca00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports